import CustomerAPI from 'config/api/CustomerAPI';
import { manageAPICall } from 'store/auth/actions/CommonCrudAction';

export const getHomepageData = async (data: object) => {
  const response = await manageAPICall(CustomerAPI.homepage.url, CustomerAPI.homepage.method, data);
  return response;
};
export const getHeaderFooterConfig = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.headerFooter.url,
    CustomerAPI.headerFooter.method,
    data
  );
  return response;
};
// header live ticker: newest listed products / FFLs / discounted products / coupons
export const getLiveUpdates = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.liveUpdates.url,
    CustomerAPI.liveUpdates.method,
    data
  );
  return response;
};
